import isNil from 'lodash/isNil';
import { SetTextDataMutation, TextDataUtils } from '../mutation/text/set-text-data-mutation';
import { shallowOmit } from '../utils/object-utils';
import { record } from '../utils/recorder';
import { cloneDeep } from '../utils/clone-deep';
import { merge } from '../utils/protoutil';
import {
    SetTextBodyPropertiesMutation,
    TextBodyPropertiesUtils,
} from '../mutation/text/set-text-body-properties-mutation';
import { BaseShapeMutationAPI } from './base-shape-mutation-api';
import type { ICTTextParagraph, ICTTextListStyle, ICTTextBodyProperties } from '@tencent/slide-sdk-pb-model';
import type { IShapeData } from '../data';
import type { DeltaOf } from '../utils/delta';
import type { ShapeDataModel } from '../model/shape-data-model';

export class ShapeMutationAPI extends BaseShapeMutationAPI<ShapeDataModel> {
    /**
     * 更新形状属性
     */
    @record()
    public updateProps({ spPr, nvPr, style, txBody, useBgFill }: DeltaOf<IShapeData>) {
        this.transaction(() => {
            if (txBody) {
                this.updateTextBodyProperties({ bodyPr: txBody.bodyPr, lstStyle: txBody.lstStyle });
            }

            super.updateProps({
                spPr,
                nvPr: nvPr && {
                    ...super.getCommonNonVisualPropsDelta(nvPr),
                    shape: {
                        txBox: nvPr.txBox === null ? false : nvPr.txBox,
                    },
                },
                // style 在中台是全量替换
                style: isNil(style) ? style : merge(cloneDeep(this.model.store.data.style ?? {}), style),
                shape: {
                    useBgFill: useBgFill === null ? false : useBgFill,
                },
            });
        });
    }

    @record()
    public updateParagraphList(paragraphList: ICTTextParagraph[]) {
        return this.transaction(() => {
            this.request([
                new SetTextDataMutation(
                    shallowOmit(
                        TextDataUtils.fromParagraphListData(paragraphList, this.model.getPage().id, this.model.id),
                        'type',
                    ),
                ),
            ]);
        });
    }

    @record()
    public updateTextBodyProperties({
        bodyPr = {},
        lstStyle = {},
    }: {
        bodyPr?: DeltaOf<ICTTextBodyProperties> | null;
        lstStyle?: DeltaOf<ICTTextListStyle> | null;
    }) {
        return this.transaction(() => {
            this.request([
                new SetTextBodyPropertiesMutation(
                    shallowOmit(
                        TextBodyPropertiesUtils.fromTextBodyProperties(
                            { bodyPr, lstStyle },
                            this.model.getPage().id,
                            this.model.id,
                        ),
                        'col',
                        'row',
                        'type',
                    ),
                ),
            ]);
        });
    }

    /**
     * 提供的全量更新 textListStyle 的接口
     * @param lstStyle
     */
    @record()
    public updateTextStyles(lstStyle: ICTTextListStyle) {
        this.transaction(() => {
            this.updateTextBodyProperties({ lstStyle: null });
            this.updateTextBodyProperties({ lstStyle });
        });
    }
}
